import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Home/Navbar';
import "./AdminLogin.css"
import END_POINT from '../../END_POINT';

const AdminLogin = () => {
  const navigate=useNavigate();
  const [admin, setAdmin] = useState({
    username:"",
    password:""
  });
  const handleInput=(e)=>{
    setAdmin({...admin,[e.target.name]:e.target.value})
    
  }
  const submitAdmin=async()=>{
    if(admin.username && admin.password){
      const res = await fetch(`${END_POINT}/auth/adminlogin`, {
        method: "POST",
        headers: { 'Content-Type': "application/json" },
        body: JSON.stringify(admin)
    })
      
    if(res.status===200){
      res.json().then(data=>{
        localStorage.setItem("Admin", JSON.stringify(data));
        navigate("/dashboard")
      })
      
    }
    else{
      alert("Invalid Login")
    }
    }
    else{
      alert("Please fil in the data")
    }
    
      
  }
  return (
      <div>
        <div className="navbarr">
        <Navbar/>
        </div>
        
        <div className="adminwrapper">
        <h2>Admin Login</h2>
          <div className="card admincard">
          
          <div className="userpass">
            <h3>Username</h3>
          <input onChange={(e)=>handleInput(e)} className='form-control '  type="text" name="username" placeholder='Username' />          <h3>Password</h3>
          <input onChange={(e)=>handleInput(e)}  className='form-control' type="password" name="password" placeholder='Password' />
          <input onClick={submitAdmin} className='my-3 btn btn-success' type="submit" value="Login" />
          </div>  
          </div>
          
        
        </div>
          
      </div>
  )
};

export default AdminLogin;
